import { DocumentPart } from './document-part';

export class Doc {
  id: number;
  matter_id: number;
  name: string;
  notes: string;
  created_by: number;
  updated_by: number;
  created_at: string;
  updated_at: string;
  document_type_id: number;
  part_data: string;
  version: number;
  form_id: number;
  matter_history_id: number;
  document_template_id: number;
  is_editable: boolean = true;
  authored_at: string;
  uploaded: boolean;
  intranet_id: number;
  autosaved: boolean = false;
  manual_history_id: number;
  billing_id: number;
  document_form_id: number;
  page_count: number;
  exhibit_id: string;
  doc_template_id: number;
  is_letter: boolean = false;
  signature_matter_user_id: number;
  attachment_ids: Array<number> = [];
  content: string;
  is_formal: boolean = true;
  attachments_included: boolean = false;
  document_parts: Array<DocumentPart> = [];
  tag_list: any;
  all_tags_list: any;
  authored_at_struct: any;
}
